import { Injectable } from '@angular/core';
import { ProcessTableObject } from 'src/app/models/orders/order-details-process/process-table/process-table-object.model';
import { ProcessActivityObject } from 'src/app/models/orders/order-details-process/process-details/process-activity-object.model';
import { TechnicalSubprocessObject } from 'src/app/models/orders/order-details-process/process-details/technical-subprocess-object.model';
import { ProcessDetailsObject } from 'src/app/models/orders/order-details-process/process-details/process-details-object.model';
import { isUndefined } from 'util';
import { AppService } from 'src/app/app.service';
import { OrderDetailsGeneralObject } from 'src/app/models/orders/order-details-general/order-details-general-object.model';
import { OrderDetailsProcessObject } from 'src/app/models/orders/order-details-process/order-details-process-object.model';
import { OrderDetailsProcessActivitiesConverter } from './specific-order/order-details-process-activities.converter';
import { OrderDetailsProcessBpmActivitiesConverter } from './specific-order/order-details-process-bpmActivities.converter';
import { TaskProcessObject } from 'src/app/models/orders/order-details-process/process-details/process-task.model';
import { TaskProcessConverter } from '../tasks/process-task/process-task.converter';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DetailsService {

  appData: any;

  constructor(
    private activitiesConverter: OrderDetailsProcessActivitiesConverter,
    private bpmActivitiesConverter: OrderDetailsProcessBpmActivitiesConverter,
    private httpClient: HttpClient,
    appService: AppService
  ) {
    this.appData = appService.settings;
  }

  public async getProcessInfo(generalInfo: OrderDetailsGeneralObject): Promise<Array<OrderDetailsProcessObject>> {

    let processTable: ProcessTableObject = ProcessTableObject.create();
    let processDetails: ProcessDetailsObject;
    let processes: Array<OrderDetailsProcessObject> = new Array<OrderDetailsProcessObject>();
    let process: OrderDetailsProcessObject;

    try {
      for (process of generalInfo.getProcesses()) {
        processTable = new ProcessTableObject(process.getProcessId(), process.getType(), process.getStatus(), process.getName());
        process.setTable(processTable);


        const processInfoData: any = await this.httpClient.get(`${this.appData.webApi}/processes/${process.getProcessId()}`).toPromise();

        if (!isUndefined(processInfoData)) {
          processDetails = this.convertTo(processInfoData, process.getProcessId());
          process.setDetails(processDetails);
        } else {
          console.error('Could not get information for process ' + process.getProcessId());
        }

        processes.push(process);
      }
      return processes;
    } catch (error) {
      console.error(error);
    }

  }

  private convertTo(processInfoData: any, processId: string): ProcessDetailsObject {

    let activityList: Array<ProcessActivityObject> = new Array<ProcessActivityObject>();
    let subprocessList: Array<TechnicalSubprocessObject> = new Array<TechnicalSubprocessObject>();
    let tasks: Array<TaskProcessObject> = new Array<TaskProcessObject>();
    let processDetails: ProcessDetailsObject;

    const startDate: Date = null;
    const endDate: Date = null;
    const finished = endDate != null;
    var error: boolean = false;

    tasks = this.getTasks(processInfoData);
    if (tasks.length > 0) {
      error = true;
    }
    processInfoData.error = error;
    activityList = this.activitiesConverter.convert(processInfoData);
    subprocessList = this.bpmActivitiesConverter.convert(processInfoData);
    processDetails = new ProcessDetailsObject(processId, startDate, endDate, activityList, subprocessList, finished, tasks);

    return processDetails;
  }

  private getTasks(processInfo: any): Array<TaskProcessObject> {
    let tasks: Array<TaskProcessObject> = [];
    if (!isUndefined(processInfo.tasks)) {
      for (const task of processInfo.tasks) {
        tasks.push(new TaskProcessConverter().convert(task));
      }
    }
    return tasks;
  }
}
